import { Recipient } from "./recipient.model";

export class AccountQuotationRecipient {
    constructor(accountCode: string, quotationCode: string, recipients: Recipient[]) {
        this.accountCode = accountCode;
        this.quotationCode = quotationCode;
        this.recipients = recipients;
    }
    accountCode: string;
    quotationCode: string;
    recipients: Recipient[];
}
